import { render, staticRenderFns } from "./CartPromoCode.vue?vue&type=template&id=c49141d6&scoped=true&"
import script from "./CartPromoCode.vue?vue&type=script&lang=js&"
export * from "./CartPromoCode.vue?vue&type=script&lang=js&"
import style0 from "./CartPromoCode.vue?vue&type=style&index=0&id=c49141d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49141d6",
  null
  
)

/* custom blocks */
import block0 from "./CartPromoCode.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

component.options.__file = "CartPromoCode.vue"
export default component.exports